<template>
  <div class="maxbox">
    <div>
      <div class="top">
        <p>后台管理设置</p>
      </div>
      <div class="main">
        <button class="return" @click="goback"><img src="@/assets/images/left-arrow.png" alt=""></button>
        <div class="main-content">
          <template v-if="isOwner">
            <!-- 提现手续费管理 -->
            <div style="margin-top:20px; border-top:1px solid #eee; padding-top:15px;">
              <p style="font-weight:bold; margin-bottom:8px; color:#8e44ad;">💱 提现手续费管理</p>
              <p style="margin:5px 0;">当前手续费比例：<span style="color:red;font-weight:bold;">{{ nowFeePercent }} %</span></p>
              <label>设置新手续费(填数字即可)：</label>
              <input type="number" v-model="inputFeePercent" placeholder="例：填3=3%" style="width:100%; margin:5px 0;" />
              <button @click="setWithdrawFee" style="background:#8e44ad; color:white; padding:6px 12px; margin-top:5px; width:100%;">
                确认设置手续费
              </button>
            </div>

            <!-- 管理员开通会员赠送矿机 -->
            <div style="margin-top:20px; border-top:1px solid #eee; padding-top:15px;">
              <p style="font-weight:bold; margin-bottom:8px;">✅ 开通会员并免费赠送矿机</p>
              <label>会员地址：</label>
              <input type="text" v-model="adminCreate_user" placeholder="输入开通用户地址" style="width:100%; margin:5px 0;" />

              <label>上级推荐人地址：</label>
              <input type="text" v-model="adminCreate_referrer" placeholder="填写已注册推荐人地址" style="width:100%; margin:5px 0;" />

              <label>选择矿机类型：</label>
              <div style="display:flex; gap:10px; margin:5px 0;">
                <button
                  style="flex:1; padding:8px; background:#f5f5f5; border:1px solid #ddd; border-radius:4px; color:#000 !important;"
                  @click="showCreateMachineModal = true">
                  {{ machineTypeName(adminCreate_machineType) }}
                </button>
              </div>

              <label>赠送矿机数量：</label>
              <input type="number" v-model="adminCreate_count" placeholder="输入赠送数量" style="width:100%; margin:5px 0;" />

              <button @click="adminCreateMember"
                style="background:green; color:white; padding:6px 12px; margin-top:5px; width:100%;">
                一键开通会员赠送矿机
              </button>
            </div>

            <!-- 给已注册用户追加矿机 -->
            <div style="margin-top:20px; border-top:1px solid #eee; padding-top:15px;">
              <p style="font-weight:bold; margin-bottom:8px;">✅ 为已有会员追加免费矿机</p>
              <label>会员地址：</label>
              <input type="text" v-model="adminAdd_user" placeholder="输入已注册会员地址" style="width:100%; margin:5px 0;" />

              <label>选择矿机类型：</label>
              <div style="display:flex; gap:10px; margin:5px 0;">
                <button
                  style="flex:1; padding:8px; background:#f5f5f5; border:1px solid #ddd; border-radius:4px; color:#000 !important;"
                  @click="showAddMachineModal = true">
                  {{ machineTypeName(adminAdd_machineType) }}
                </button>
              </div>

              <label>追加数量：</label>
              <input type="number" v-model="adminAdd_count" placeholder="输入追加数量" style="width:100%; margin:5px 0;" />

              <button @click="adminAddMachineToMember"
                style="background:orange; color:white; padding:6px 12px; margin-top:5px; width:100%;">
                确认追加矿机
              </button>
            </div>

            <!-- 提现冻结解冻 -->
            <div style="margin-top:20px;border-top:1px solid #eee;padding-top:15px;">
              <p style="font-weight:bold;margin-bottom:8px;">🔒 会员提现权限管理</p>
              <label>目标会员地址：</label>
              <input type="text" v-model="userAddress" placeholder="输入会员地址" style="width:100%;margin:5px 0"/>
              <div style="display:flex;gap:10px;margin-top:5px;">
                <button @click="freezeWithdraw" style="flex:1;background:#e74c3c;color:white;padding:6px 0;">冻结提现</button>
                <button @click="unfreezeWithdraw" style="flex:1;background:#27ae60;color:white;padding:6px 0;">解除冻结</button>
              </div>
            </div>

            <div style="margin-top:15px;">
              <label>查询会员冻结状态：</label>
              <input type="text" v-model="userAddressStatus" placeholder="输入会员地址" style="width:100%;margin:5px 0"/>
              <button @click="checkWithdrawalStatus" style="width:100%;background:#3498db;color:white;padding:6px 0;">查询状态</button>
              <p v-if="withdrawalStatus !== undefined" style="margin-top:5px;">
                账户状态：{{ withdrawalStatus ? '已冻结禁止提现' : '正常可提现' }}
              </p>
            </div>

            <!-- 分红周期设置 -->
            <div class="period-box" style="margin-top:20px;border-top:1px solid #eee;padding-top:15px;">
              <p style="font-weight:bold;margin-bottom:8px;">⏱ 分红运行周期设置</p>
              <p>当前分红周期：<span class="current-period">{{ currentDividendPeriod }} 天</span></p>
              <label>设置新周期（天数）：</label>
              <input type="number" v-model="newPeriod" placeholder="填写周期天数" style="width:100%;margin:5px 0;"/>
              <button @click="setMachineDividendPeriod" style="width:100%;background:#9b59b6;color:white;padding:6px 0;">确认修改周期</button>
            </div>

            <!-- 代币地址更换 -->
            <div style="margin-top:20px;border-top:1px solid #eee;padding-top:15px;">
              <p style="font-weight:bold;margin-bottom:8px;">💳 结算代币地址配置</p>
              <label>新代币合约地址：</label>
              <input type="text" v-model="newSbsTokenAddress" placeholder="输入全新ERC20代币地址" style="width:100%;margin:5px 0;"/>
              <button @click="setSBSTokenAddress" style="width:100%;background:#c0392b;color:white;padding:6px 0;">更换代币地址</button>
            </div>

            <!-- 矿机价格配置 -->
            <div style="margin-top:20px;border-top:1px solid #eee;padding-top:15px;">
              <p style="font-weight:bold;margin-bottom:8px;">💰 商城矿机售价配置</p>
              <label>选择修改类型：</label>
              <button
                style="width:100%; padding:8px; background:#f5f5f5; border:1px solid #ddd; border-radius:6px; color:#000 !important;margin:5px 0;"
                @click="showPriceMachineModal = true">
                {{ machineTypeName(machineType) }}
              </button>
              <label>设置新价格（纯数字不带小数）：</label>
              <input type="number" v-model="newMachinePrice" placeholder="输入价格" style="width:100%;margin:5px 0;"/>
              <button @click="setMachinePrice" style="width:100%;background:#f39c12;color:white;padding:6px 0;">保存修改价格</button>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- 矿机类型选择弹窗 -->
    <div v-if="showCreateMachineModal || showAddMachineModal || showPriceMachineModal"
      style="position:fixed; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5); display:flex; align-items:center; justify-content:center; z-index:9999;"
      @click.self="closeAllModals">
      <div style="background:white; width:80%; border-radius:10px; padding:20px;">
        <p style="font-weight:bold; text-align:center; margin-bottom:15px;">选择矿机类型</p>
        <button v-for="item in machineList" :key="item.value"
          style="width:100%; padding:12px; margin:6px 0; background:#f3f3f3; border:none; border-radius:6px;"
          @click="selectMachineType(item.value)">
          {{ item.label }}
        </button>
        <button
          style="width:100%; padding:12px; margin-top:10px; background:#ff4444; color:white; border:none; border-radius:6px;"
          @click="closeAllModals">
          关闭
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ethers } from 'ethers';
import { contractAddress, contractABI } from '@/js/contract.js';

export default {
  name: 'settings',
  data() {
    return {
      isOwner: false,
      userAddress: '',
      userAddressStatus: '',
      withdrawalStatus: undefined,
      newPeriod: '',
      currentDividendPeriod: 0,
      newSbsTokenAddress: '',
      machineType: '0',
      newMachinePrice: '',
      adminCreate_user: '',
      adminCreate_referrer: '',
      adminCreate_machineType: '0',
      adminCreate_count: 1,
      adminAdd_user: '',
      adminAdd_machineType: '0',
      adminAdd_count: 1,
      showCreateMachineModal: false,
      showAddMachineModal: false,
      showPriceMachineModal: false,
      machineList: [
        { value: '0', label: '1号矿机' },
        { value: '1', label: '2号矿机' },
        { value: '2', label: '3号矿机' },
      ],
      provider: null,
      signer: null,
      contract: null,
      nowFeePercent: 2,
      inputFeePercent: ''
    };
  },
  mounted() {
    this.initializeContract();
  },
  methods: {
    goback() {
      this.$router.go(-1);
    },
    async initializeContract() {
      await this.connectWallet();
      await this.checkOwnership();
      await this.getCurrentDividendPeriod();
      await this.getNowWithdrawFee();
    },
    async connectWallet() {
      try {
        if (typeof window.ethereum !== 'undefined') {
          this.provider = new ethers.providers.Web3Provider(window.ethereum);
          await this.provider.send("eth_requestAccounts", []);
          this.signer = this.provider.getSigner();
          this.contract = new ethers.Contract(contractAddress, contractABI, this.signer);
        } else {
          alert('未检测到钱包，请安装MetaMask');
        }
      } catch (error) {
        console.error('连接钱包失败:', error);
        alert('连接钱包失败！');
      }
    },
    async checkOwnership() {
      try {
        const currentAccount = await this.signer.getAddress();
        const ownerAddress = await this.contract.owner();
        this.isOwner = currentAccount.toLowerCase() === ownerAddress.toLowerCase();
      } catch (error) {
        console.error('权限校验失败:', error);
      }
    },
    async getNowWithdrawFee(){
      try{
        const fee = await this.contract.withdrawFeePercent();
        this.nowFeePercent = Number(fee.toString());
      }catch(e){
        console.log("读取手续费失败",e);
      }
    },
    async setWithdrawFee(){
      if(!this.isOwner){alert("仅管理员可操作");return;}
      if(!this.inputFeePercent || this.inputFeePercent <0 || this.inputFeePercent>100){
        alert("请输入0-100有效数字");
        return;
      }
      try{
        const tx = await this.contract.setWithdrawFeePercent(this.inputFeePercent);
        await tx.wait();
        alert("✅ 手续费设置成功");
        await this.getNowWithdrawFee();
        this.inputFeePercent = '';
      }catch(e){
        alert("设置失败："+e.message);
      }
    },
    machineTypeName(val) {
      const item = this.machineList.find(v => v.value === val);
      return item ? item.label : '选择矿机';
    },
    selectMachineType(val) {
      if (this.showCreateMachineModal) this.adminCreate_machineType = val;
      if (this.showAddMachineModal) this.adminAdd_machineType = val;
      if (this.showPriceMachineModal) this.machineType = val;
      this.closeAllModals();
    },
    closeAllModals() {
      this.showCreateMachineModal = false;
      this.showAddMachineModal = false;
      this.showPriceMachineModal = false;
    },
    // 开通会员赠送矿机
    async adminCreateMember() {
      if (!this.isOwner) { alert("仅管理员可操作"); return; }
      if (!ethers.utils.isAddress(this.adminCreate_user)) { alert("会员地址格式错误"); return; }
      if (!ethers.utils.isAddress(this.adminCreate_referrer)) { alert("推荐人地址格式错误"); return; }
      if (this.adminCreate_count <= 0) { alert("赠送数量必须大于0"); return; }
      try {
        const tx = await this.contract.adminCreateMember(
          this.adminCreate_user,
          this.adminCreate_referrer,
          this.adminCreate_machineType,
          this.adminCreate_count
        );
        await tx.wait();
        alert("✅ 会员开通成功，已自动赠送矿机");
        this.adminCreate_user = "";
        this.adminCreate_referrer = "";
        this.adminCreate_count = 1;
      } catch (e) {
        alert("开通失败：" + e.message);
      }
    },
    // 追加矿机
    async adminAddMachineToMember() {
      if (!this.isOwner) { alert("仅管理员可操作"); return; }
      if (!ethers.utils.isAddress(this.adminAdd_user)) { alert("会员地址无效"); return; }
      if (this.adminAdd_count <= 0) { alert("数量必须大于0"); return; }
      try {
        const tx = await this.contract.adminAddMachineToMember(
          this.adminAdd_user,
          this.adminAdd_machineType,
          this.adminAdd_count
        );
        await tx.wait();
        alert("✅ 矿机追加成功");
        this.adminAdd_user = "";
        this.adminAdd_count = 1;
      } catch (e) {
        alert("追加失败：" + e.message);
      }
    },
    async getCurrentDividendPeriod() {
      try {
        const period = await this.contract.machineDividendPeriod();
        this.currentDividendPeriod = period.toString();
      } catch (e) {
        console.error("获取周期失败", e);
      }
    },
    async setSBSTokenAddress() {
      if (!this.isOwner) { alert("仅管理员可操作"); return; }
      if (!ethers.utils.isAddress(this.newSbsTokenAddress)) {
        alert("请输入合法代币地址");
        return;
      }
      try {
        const tx = await this.contract.setSBSTokenAddress(this.newSbsTokenAddress);
        await tx.wait();
        alert("✅ 代币地址更换成功");
        this.newSbsTokenAddress = "";
      } catch (e) {
        alert("操作失败：" + e.message);
      }
    },
    // 已修复：价格自动乘以10^6 适配合约6位小数精度
    async setMachinePrice() {
      if (!this.isOwner) { alert("仅管理员可操作"); return; }
      if (!this.newMachinePrice || this.newMachinePrice <= 0) {
        alert("请输入有效价格");
        return;
      }
      const realPrice = ethers.BigNumber.from(this.newMachinePrice).mul(ethers.BigNumber.from(10).pow(6));
      try {
        const tx = await this.contract.setMachinePrice(
          this.machineType,
          realPrice
        );
        await tx.wait();
        alert("✅ 矿机价格修改成功");
        this.newMachinePrice = "";
      } catch (e) {
        alert("修改失败：" + e.message);
      }
    },
    async freezeWithdraw() {
      if (!ethers.utils.isAddress(this.userAddress)) {
        alert('请输入合法会员地址');
        return;
      }
      try {
        const tx = await this.contract.freezeWithdraw(this.userAddress);
        await tx.wait();
        alert('✅ 已冻结该用户提现权限');
      } catch (error) {
        alert('冻结失败：' + error.message);
      }
    },
    async unfreezeWithdraw() {
      if (!ethers.utils.isAddress(this.userAddress)) {
        alert('请输入合法会员地址');
        return;
      }
      try {
        const tx = await this.contract.unfreezeWithdraw(this.userAddress);
        await tx.wait();
        alert('✅ 已解除提现冻结');
      } catch (error) {
        alert('解冻失败：' + error.message);
      }
    },
    async checkWithdrawalStatus() {
      if (!ethers.utils.isAddress(this.userAddressStatus)) {
        alert('请输入合法会员地址');
        return;
      }
      try {
        this.withdrawalStatus = await this.contract.getUserWithdrawFrozenStatus(this.userAddressStatus);
      } catch (error) {
        this.withdrawalStatus = undefined;
        alert('查询失败：' + error.message);
      }
    },
    async setMachineDividendPeriod() {
      if (!this.newPeriod || this.newPeriod <= 0) {
        alert('请填写有效周期天数');
        return;
      }
      try {
        const tx = await this.contract.setMachineDividendPeriod(this.newPeriod);
        await tx.wait();
        alert('✅ 分红周期修改成功');
        await this.getCurrentDividendPeriod();
        this.newPeriod = '';
      } catch (error) {
        alert('修改失败：' + error.message);
      }
    }
  }
}
</script>

<style scoped>
@import "@/assets/css/settings.css";
@import "@/assets/css/style.css";
.main {
  padding-top: 50px;
}
.period-box {
  margin: 15px 0;
  font-size: 16px;
}
.current-period {
  color: red;
  font-weight: bold;
  font-size: 18px;
}
</style>